import Spline from '@splinetool/react-spline';

export default function App() {
  return (
    <Spline className='hidden mb-0 ml-16 md:justify-center md:items-center md:ml-0 tab:ml-0 md:flex tab:flex xl:ml-0 tab:items-center tab:justify-center' scene="https://prod.spline.design/KLht10mvmOQMGpD5/scene.splinecode" />
  );
}
